<!--view for phrases-->
<template>
    <div class="profile">
    <Heading/>
    <div class="flex justify-center">
      <div class="col-12 max-width-4 mx-auto my4 px3 center">
        <h1 class="mt0 mb2">Fraasit</h1>
        <div class="h5 mb3">
        <p>Fraasit ovat valmiita tekstipätkiä, joita voi liittää keskusteluun #-merkkiä käyttämällä.</p>
        <p v-if="profile.admin">Ylläpitonäkymässä voit jakaa käyttäjäryhmällesi fraaseja. Luo jaettu fraasi kirjoittamalla sen nimi alkamaan ##-merkeillä.</p>
        </div>

        <div v-if="profile.admin">
          <label class="custom-control">
            <input type="checkbox" name="questionnaire" v-model="showProfilePhrases">
            <span class="custom-control-indicator"></span>
            <span>Näytä omat fraasit</span>
          </label>
          <label class="custom-control">
            <input type="checkbox" name="questionnaire" v-model="showCompanyPhrases">
            <span class="custom-control-indicator"></span>
            <span>Näytä jaetut fraasit</span>
          </label>
        </div>

        <div class="border-top border-gray-4">
          <Phrases />
          <ListPhrases v-for="phrase in visiblePhrases" :phrase="phrase" :key="(phrase.company ? '##' : '#') + phrase.hashtag"></ListPhrases>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import Heading from '@/components/Heading.vue';
import ListPhrases from '@/components/PhrasesEditItem.vue';
import Phrases from '@/components/PhraseAdder.vue';
import { mapGetters } from "vuex";

export default {
  name: 'Profile',
  components: { Heading, Phrases, ListPhrases},
  mounted: function() {
    this.$store.dispatch('getProfile');
  },
  data() {
    return {
      showProfilePhrases: true,
      showCompanyPhrases: false,
    };
  },
  computed: {
    ...mapGetters({
        profile: 'profile',
        profilePhrases: 'profilePhrases',
        companyPhrases: 'companyPhrases',
    }),
    visiblePhrases: {
      get() {
        return [
          ...(this.showProfilePhrases ? this.profilePhrases : []),
          ...(this.profile.admin && this.showCompanyPhrases ? this.companyPhrases : []),
        ];
      }
    },
},
}
</script>

<style scoped>
  .custom-control {
    position: relative;
    display: block;
    padding-bottom: var(--space-1);
    padding-left: var(--space-3);
    cursor: pointer;
    line-height: var(--line-height-4);
    font-weight: normal;
  }

  .custom-control input[type=checkbox] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }

  .custom-control input[type=checkbox]:checked~.custom-control-indicator {
    color: var(--white);
    background-color: var(--blue);
    box-shadow: none;
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2213%22%20height%3D%228%22%20viewBox%3D%220%200%2013%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%204.5L4.5%208l8-8%22%20stroke%3D%22%23FFF%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E");
  }

  .custom-control-indicator {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 1.375rem;
    height: 1.375rem;
    line-height: 1.375rem;
    font-size: 65%;
    text-align: center;
    border-radius: 99px;
    background-color: var(--gray);
    background-repeat: no-repeat;
    background-position: center;
  }

  .custom-control:hover .custom-control-indicator {
    background-color: var(--gray-4);
  }
</style>
